import React from "react";
import Flagship from "../../core/flagship";
import Field from "../misc/Field";
import { connect } from "react-redux";
import { Loader, Header, Grid, Modal, Button, Icon } from "semantic-ui-react";
import {
  shouldShowField,
  empty,
  getServiceNiceName,
} from "../../utils/helpers";
import FlightField from "../misc/FlightField";

class LineItemEditModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editName = this.editName.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.getLineItemForm = this.getLineItemForm.bind(this);
    this.getFormSubService = this.getFormSubService.bind(this);
    this.getSubServiceFields = this.getSubServiceFields.bind(this);
    this.checkRequired = this.checkRequired.bind(this);
    this.setFlightSubFieldsMissing = this.setFlightSubFieldsMissing.bind(this);
    this.onUpdateFlights = this.onUpdateFlights.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      id: this.props.lineItemId,
      lineItemName: this.props.lineItem.line_item_name,
      parent_rfp: 0,
      vendor: "",
      cogs: "",
      price: "",
      errors: [],
      lineItemData: {},
      lineItemForm: [],
      originalLineItemData: [],
      changed: false,
      requiredMissing: true,
      flights: this.props.lineItem.flights,
      flighted: false,
      flightSubFieldsMissing: false,
    };
  }

  componentDidMount() {
    // Get Form
    this.getLineItemForm();
  }

  getLineItemForm() {
    let self = this;
    let service = this.props.lineItem.line_item_type;

    let mainService = false;
    let subService = false;
    let flighted = false;

    Flagship.config.lineItemServices.map(function (element) {
      if (element.value === service) {
        mainService = service;
        flighted = element.flighted;
      } else if (element.hasOwnProperty("subOptions")) {
        element.subOptions.map(function (subItem) {
          if (subItem.value === service) {
            mainService = element.value;
            flighted = subItem.flighted;
            subService = service;
          }
        });
      }
    });

    if (subService !== false) {
      // If dealing with a sub-service, get both levels of fields

      this.getFormSubService(mainService, subService, flighted);
    } else {
      Flagship.get(
        "fields/line-item_" + mainService,
        {
          withData:
            typeof this.props.lineItemId === "undefined"
              ? false
              : this.props.lineItemId,
          dataSource: "line_item",
          active: true,
          instance: this.props.instance,
        },
        function (response) {
          if (response.data.success === true) {
            self.setState(
              {
                loading: false,
                lineItemData: response.data.fieldData,
                originalLineItemData: response.data.fieldData,
                lineItemForm: response.data.results,
                trueService: mainService,
                flighted,
              },
              self.checkRequired
            );
          } else {
            Flagship.error(
              "Error getting line item form from Flagship API server.",
              self.props.recordId,
              self.props.userId
            );
          }
        },
        function (err) {
          Flagship.error(
            "Error getting line item form from Flagship API server: " + err,
            self.props.recordId,
            self.props.userId
          );
        }
      );
    }
  }

  getFormSubService(mainService, subService, flighted) {
    let self = this;

    // First get main service fields
    Flagship.get(
      "fields/line-item_" + mainService,
      {
        withData:
          typeof this.props.lineItemId === "undefined"
            ? false
            : this.props.lineItemId,
        dataSource: "line_item",
        active: true,
      },
      function (response) {
        if (response.data.success === true) {
          self.setState(
            {
              lineItemForm: response.data.results,
              lineItemData: response.data.fieldData,
              originalLineItemData: response.data.fieldData,
              trueService: subService,
              flighted,
            },
            function () {
              self.getSubServiceFields(subService);
            }
          );
        } else {
          Flagship.error(
            "Error getting line item form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting line item form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getSubServiceFields(subService) {
    let self = this;

    // Now add sub service fields
    Flagship.get(
      "fields/line-item_" + subService,
      {
        withData:
          typeof this.props.lineItemId === "undefined"
            ? false
            : this.props.lineItemId,
        dataSource: "line_item",
        active: true,
      },
      function (response) {
        if (response.data.success === true) {
          let combinedForm = [
            ...self.state.lineItemForm,
            ...response.data.results,
          ];
          let combinedData = Object.assign(
            self.state.lineItemData,
            response.data.fieldData
          );

          self.setState(
            {
              lineItemForm: combinedForm,
              lineItemData: combinedData,
              loading: false,
            },
            self.checkRequired
          );
        } else {
          Flagship.error(
            "Error getting line item form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting line item form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) === -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors,
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors,
    });
  }

  checkRequired() {
    let requiredMissing = false;
    let self = this;

    this.state.lineItemForm.length &&
      this.state.lineItemForm.map(function (item) {
        if (
          self.state.flightSubFieldsMissing ||
          ((item.required === true || item.required === 1) &&
            empty(self.state.lineItemData[item.field_id]) &&
            shouldShowField(item, self.state.lineItemData))
        ) {
          requiredMissing = true;
        }
      });

    this.setState({
      requiredMissing: requiredMissing,
    });
  }

  setFlightSubFieldsMissing(flightSubFieldsMissing) {
    this.setState(
      {
        flightSubFieldsMissing,
      },
      this.checkRequired
    );
  }

  onUpdateFlights(flights) {
    this.checkRequired();

    this.setState({
      flights: flights,
    });
  }

  onChange(e, data, field) {
    if (field === "name") {
      this.setState({
        lineItemName: e.target.value,
      });
    } else if (field === "flights") {
      this.onUpdateFlights(data);
    } else {
      let newLineItemData = Object.assign({}, this.state.lineItemData);
      newLineItemData[field] = data;

      this.setState(
        {
          changed: true,
          lineItemData: newLineItemData,
        },
        this.checkRequired
      );
    }
  }

  editName() {
    this.setState({
      editingName: true,
    });
  }

  saveAndExit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    Flagship.post(
      "line-item/update/" + self.props.lineItemId,
      {
        data: self.state.lineItemData,
        name: self.state.lineItemName,
        flights: self.state.flights,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.event(
            "update-line-item",
            {
              lineItemId: self.props.lineItemId,
              lineItemKey: self.props.lineItem.line_item_key,
              lineItemName: self.state.lineItemName,
              lineItemType: self.props.lineItem.line_item_type,
              oldData: self.state.originalLineItemData,
              newData: self.state.lineItemData,
            },
            self.props.recordId,
            self.props.userId
          );
          Flagship.notify("Line item updated.");
          self.setState(self.getInitialState(), function () {
            if (typeof self.props.onUpdateLineItem === "function") {
              self.props.onUpdateLineItem();
            }
          });
        } else {
          Flagship.error(
            "Error updating line item.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error updating line item: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  render() {
    if (this.state.loading === true) {
      return <Loader />;
    } else {
      let self = this;
      let serviceNiceName = getServiceNiceName(
        this.props.lineItem.line_item_type
      );
      return (
        <Modal
          open={this.props.open}
          onClose={this.props.cancelUpdate}
          closeIcon
          closeOnDimmerClick={false}
        >
          {this.state.changed === false ? (
            <Button
              floated="right"
              className="view-edit-line-item"
              onClick={this.props.swapToView}
            >
              <Icon name="eye" />
              View Line Item
            </Button>
          ) : (
            <span className="line-item-modified float-right">Modified</span>
          )}
          <Header>
            {this.props.lineItem.line_item_key + " - "}

            {this.state.editingName === true ? (
              <span className="ui input">
                <input
                  autoFocus
                  placeholder={self.state.lineItemName}
                  onChange={(e, data) => self.onChange(e, data, "name")}
                  style={{
                    minWidth: "400px",
                    maxWidth: "100%",
                  }}
                />
              </span>
            ) : (
              [
                <span className="editable-title" onClick={self.editName}>
                  {self.state.lineItemName}
                </span>,
                <div>
                  {serviceNiceName !== self.state.lineItemName ? (
                    <div className="gray-text">
                      <small> ({serviceNiceName}) </small>
                    </div>
                  ) : null}
                </div>,
              ]
            )}
          </Header>
          <Modal.Content>
            <div>
              <Grid>
                <Grid.Column width={16}>
                  <Header as="h3">Edit Line Item Info</Header>
                  {this.state.flighted === true ? (
                    <div className="flight-field-container clearfix">
                      <FlightField
                        {...this.props.attributes}
                        fields={this.props.options}
                        value={this.state.flights}
                        fieldId="flights"
                        onChange={(e, data) => {
                          this.onChange(e, data, "flights");
                        }}
                        social={this.state.trueService === "social-media-ads"}
                        email={this.state.trueService === "email-marketing"}
                        recordType="RFP"
                        setFlightSubFieldsMissing={
                          self.setFlightSubFieldsMissing
                        }
                      />
                    </div>
                  ) : null}

                  {this.state.lineItemForm.length &&
                    this.state.lineItemForm.map(function (item, i) {
                      if (!empty(self.state.lineItemData)) {
                        let value = self.state.lineItemData.hasOwnProperty(
                          item.field_id
                        )
                          ? self.state.lineItemData[item.field_id]
                          : "";

                        return shouldShowField(
                          item,
                          self.state.lineItemData
                        ) ? (
                          <Field
                            contentType="lineItem"
                            addError={self.addError.bind(self)}
                            clearError={self.clearError.bind(self)}
                            model={"LineItem." + i}
                            key={"field-" + i}
                            value={value}
                            default={item.default}
                            filterInput={
                              item.validation !== "" ? item.validation : null
                            }
                            onChange={(e, data, fieldId) =>
                              self.onChange(e, data, fieldId, i)
                            }
                            {...item}
                          />
                        ) : null;
                      }
                    })}
                </Grid.Column>
              </Grid>
            </div>
          </Modal.Content>
          <Modal.Actions>
            {this.state.requiredMissing === false ? (
              <Button primary onClick={this.saveAndExit}>
                <Icon name="plus" /> Update Line Item
              </Button>
            ) : (
              <span className="red-text">
                {this.state.flightSubFieldsMissing
                  ? "Missing required flight data."
                  : "Required fields missing."}
              </span>
            )}
            <Button color="grey" onClick={this.props.cancelUpdate}>
              <Icon name="dont" /> Cancel
            </Button>
          </Modal.Actions>
        </Modal>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance,
  };
}

export default connect(mapStateToProps, null)(LineItemEditModal);



// WEBPACK FOOTER //
// ./src/components/modals/LineItemEditModal.js